import * as _ from "lodash";
import { Components } from "formiojs";
import * as moment from "moment";

const DatagridComponent = Components.components.datagrid;

export default class MiProMedHistDatagridComponent extends DatagridComponent {

    static schema() {
        return DatagridComponent.schema({
            type: "miproMedHistDatagrid",
            label: "Medication History",
            key: "dbo.mipro.miproMedHistDatagrid",
            disableAddingRemovingRows: true,
            components: [
                {
                    "label": "Prescribed on",
                    "tableView": false,
                    "disabled": true,
                    "datePicker": {
                        "disableWeekends": false,
                        "disableWeekdays": false
                    },
                    "timePicker": {
                        "showMeridian": false
                      },
                    "enableMinDateInput": false,
                    "enableMaxDateInput": false,
                    "key": "MHPrescribedDateTime",
                    "type": "datetime",
                    "input": true,
                    "format": "dd-MM-yyyy HH:mm",
                    "locale": "en",
                     "useLocaleSettings": true,

                    "widget": {
                        "type": "calendar",
                        "displayInTimezone": "viewer",
                        "locale": "en",
                        "useLocaleSettings": true,
                        "allowInput": true,
                        "mode": "single",
                        "enableTime": true,
                        "noCalendar": false,
                        "format": "dd-MM-yyyy HH:mm",
                        "hourIncrement": 1,
                        "minuteIncrement": 1,
                        "time_24hr": true,
                        "minDate": null,
                        "disableWeekends": false,
                        "disableWeekdays": false,
                        "maxDate": null
                    }
                },
                {
                  type: "textfield",
                  key: "MHDrugName",
                  label: "Drug Name",
                  "disabled": true,
                  input: true
                },
                {
                    type: "textfield",
                    key: "MHDose",
                    label: "Dose",
                    "disabled": true,
                    input: true
                },
                {
                    "label": "Frequency",
                    "applyMaskOn": "change",
                    "mask": false,
                    "tableView": false,
                    "delimiter": false,
                    "requireDecimal": false,
                    "inputFormat": "plain",
                    "truncateMultipleSpaces": false,
                    "key": "MHInterval",
                    "type": "number",
                    "disabled": true,
                    "input": true
                },
                {
                    type: "textfield",
                    key: "MHroute",
                    label: "Route",
                    "disabled": true,
                    input: true
                  },
              ]
        });
    }

    init() {
        super.init();
    }

    attach(element) {
        super.attach(element);
        var value = this.getValue();
        if (Array.isArray(value) && value.length > 0) {
            var updatedDateUTC = value[0].MHPrescribedDateTime;

            if (updatedDateUTC) {
                const localDate = moment.utc(updatedDateUTC, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
                value[0].MHPrescribedDateTime = localDate;
                this.setValue(value, {});
            }
        }
    }


    static get builderInfo() {
        return {
            title: "ORB MedHistory",
            group: "basic",
            icon: "table",
            weight: 70,
            schema: MiProMedHistDatagridComponent.schema(),
        };
    }

}

Components.addComponent("miproMedHistDatagrid", MiProMedHistDatagridComponent);